/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { WINDOW } from '../../common/services/window.service';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {

  constructor(@Inject(WINDOW) private window: Window, private location: Location) { }

  /**
   * This method returns true if the user is on iOS.
   */
  checkIfOnIOS(): boolean {
    // Check if on an iOS device.
    const isIPad = this.window.navigator.platform.toLowerCase().includes('ipad');
    const isIPhone = this.window.navigator.platform.toLowerCase().includes('iphone');
    const isIPod = this.window.navigator.platform.toLowerCase().includes('ipod');

    // Handle iOS devices that requested Desktop mode.
    const isMac = this.window.navigator.platform.toLowerCase().includes('macintel');
    const hasTouchscreen = this.window.navigator.maxTouchPoints > 0;
    const isIOSWithShowDesktopModeEnabled = isMac && hasTouchscreen;

    const isIOS = isIPad || isIPhone || isIPod || isIOSWithShowDesktopModeEnabled;

    return isIOS;
  }

  isFromClever(): boolean {
    return this.window.document.referrer.toLowerCase().includes('clever.com');
  }

  isStillDismissed(): boolean {
    return this.window.sessionStorage.mobileOpenInAppDismissedUntil > new Date();
  }

  setDismissed(): void {
    const tomorrow = new Date().getTime() + (8 * 60 * 60 * 1000);
    this.window.sessionStorage.mobileOpenInAppDismissedUntil = tomorrow;
  }

  /**
   * This method will try to open the mobile app.
   */
  openIOSApp() {
    this.location.go('/b/mobileLaunch');
    this.window.sessionStorage.mobileOpenInAppDismissedUntil = undefined;
  }
}
